import React from 'react';
import cn from 'classnames';

import SuccessfulMonitor from 'shared/ui/icons/SuccessfulMonitor';
import ProblemMonitor from 'shared/ui/icons/ProblemMonitor';

import ISummaryHttpMonitors from 'features/http/model/HttpMonitor/ISummaryHttpMonitors';

import styles from './StatHttpMonitorHeader.module.scss';

interface IStatHttpMonitorHeaderProps {
    items: ISummaryHttpMonitors | undefined;
}

const StatHttpMonitorHeader: React.FC<IStatHttpMonitorHeaderProps> = ({items}) => {

    return (
        <div className={styles.container}>
            <div className={cn(styles.item, styles.green)}>
                <SuccessfulMonitor/>
                {items?.percent_active_ok_monitors}%
            </div>
            <div className={cn(styles.item, styles.red)}>
                <ProblemMonitor/>
                {items?.percent_active_problem_monitors}%
            </div>
        </div>
    );
};

export default StatHttpMonitorHeader;